// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20nqN","newExpiryDate":"styles_newExpiryDate__3fr3x","footer":"styles_footer__VpVcd"};